import { FormattedMessage } from 'react-intl';

import { ConfirmationModal } from '@/modules/modals';

import { useImportValidationModal } from '../../hooks/useImportValidationModal';

export const ImportValidationModal = () => {
    const { visible, report, handleAccept, handleClose } = useImportValidationModal();

    const skippedPersonal = report?.personalSecretError ?? 0;
    // Without a report there is nothing better to say than the historical mismatch text.
    const hasMismatch = !report || report.invalidUserError > 0 || report.invalidGroupError > 0;

    return (
        <ConfirmationModal
            open={visible}
            okButton={{
                onClick: handleAccept,
                children: <FormattedMessage id='import.modal.validation.ok' />,
            }}
            cancelButton={{
                onClick: handleClose,
                children: <FormattedMessage id='import.modal.validation.cancel' />,
            }}
        >
            {skippedPersonal > 0 && (
                <>
                    <FormattedMessage id='import.modal.validation.personalSkipped' values={{ count: skippedPersonal }} />{' '}
                </>
            )}
            <FormattedMessage id={hasMismatch ? 'import.modal.validation.content' : 'import.modal.validation.continue'} />
        </ConfirmationModal>
    );
};
